import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('@/pages/home/page'));
const NotFound = lazy(() => import('@/pages/NotFound'));
const ReservationPage = lazy(() => import('@/pages/reservation/page'));
const ManageDatesPage = lazy(() => import('@/pages/manage-dates/page'));
const JaPage = lazy(() => import('@/pages/ja/page'));
const ZhCnPage = lazy(() => import('@/pages/zh-cn/page'));
const ZhTwPage = lazy(() => import('@/pages/zh-tw/page'));
const EnPage = lazy(() => import('@/pages/en/page'));
const KoPage = lazy(() => import('@/pages/ko/page'));
const JaReservationPage = lazy(() => import('@/pages/ja/reservation/page'));
const EnReservationPage = lazy(() => import('@/pages/en/reservation/page'));
const ZhTwReservationPage = lazy(() => import('@/pages/zh-tw/reservation/page'));
const ZhCnReservationPage = lazy(() => import('@/pages/zh-cn/reservation/page'));
const KoReservationPage = lazy(() => import('@/pages/ko/reservation/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/ja',
    element: <JaPage />,
  },
  {
    path: '/ja/reservation',
    element: <JaReservationPage />,
  },
  {
    path: '/zh-cn',
    element: <ZhCnPage />,
  },
  {
    path: '/zh-cn/reservation',
    element: <ZhCnReservationPage />,
  },
  {
    path: '/zh-tw',
    element: <ZhTwPage />,
  },
  {
    path: '/zh-tw/reservation',
    element: <ZhTwReservationPage />,
  },
  {
    path: '/en',
    element: <EnPage />,
  },
  {
    path: '/en/reservation',
    element: <EnReservationPage />,
  },
  {
    path: '/ko',
    element: <KoPage />,
  },
  {
    path: '/ko/reservation',
    element: <KoReservationPage />,
  },
  {
    path: '/reservation',
    element: <ReservationPage />,
  },
  {
    path: '/manage-dates',
    element: <ManageDatesPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
